export const useGetTeamListKey = (name, person, director, page, pageSize) => [
  'useGetTeamListKey',
  name,
  person,
  director,
  page,
  pageSize,
];
